import { render } from "./SurveyAnswerPicker.vue?vue&type=template&id=32d908a6"
import script from "./SurveyAnswerPicker.vue?vue&type=script&lang=js"
export * from "./SurveyAnswerPicker.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__